<div class="mon-dialog-header">
    <page-header [header]="issue.name | translateSeoIssue"
                 [subHeader]="(pages.total || 0) + ' ' + ('page with this issue' | translateWithPlural:pages.total:'pages with this issue')"
                 panelLeftClass="col-32 col-md-28 col-lg-30"
                 panelRightClass="col-16 col-md-20 col-lg-18"
                 panelClass="row flex-nowrap">
        <page-header-content>
            <div class="d-flex mon-dialog-delay-fadein">
                <div class="p-1 mr-1">
                    <a *ngIf="'table_filters' | activeFeature"
                       (click)="isFiltersOpen = !isFiltersOpen"
                       class="text-link inline-block outer-t-small cursor-pointer">
                        <span class="fas fa-filter fa-lg"></span>
                    </a>
                </div>

                <div class="p-1">
                    <csv-export-button
                            [exports]="exports"
                            clsSize="py-2 px-3"
                            clsMargin="mr-0"
                    >
                    </csv-export-button>
                </div>

                <div class="col-38 col-md-43 col-lg-43 inner-r-large outer-t-mini">
                    <table-search [minSearchLength]="3"
                                  class="block outer-r-small"
                                  theme="grey-theme"
                                  [placeholderTxt]="'Search...' | translate"
                                  [model]="search"
                                  (getPage)="onSearch($event)">
                    </table-search>
                </div>
            </div>
        </page-header-content>
    </page-header>
</div>
<div class="mon-dialog-body">
    <div class="mx-4">
        <quick-help-compliance-status type="seo"
                                      [data]="issue"
                                      [totalPagesCount]="pageCount"
                                      [totalPageIssues]="issue.pages_count">
        </quick-help-compliance-status>
    </div>
    <div class="card panel-monsido-card mx-4">
        <div class="card-body">
            <div class="row">
                <div class="col-48" [ngClass]="{'merge-t-16': isFiltersOpen}">
                    <table-filters [(open)]="isFiltersOpen"
                                   [(ngModel)]="filters"
                                   [filters]="availableFilters"
                                   *ngIf="'table_filters' | activeFeature"
                                   (onChanges)="onFiltersChanged($event)">
                    </table-filters>
                </div>
            </div>
            <div class="row">
                <div class="col-48">
                    <table-container [collection]="pages"
                                     (onPageChange)="onPageChange($event)"
                                     (onPerPageChange)="onPageSizeChange($event)"
                                     [progress]="progress"
                                     class="pages-table-wrapper">
                        <table class="table table-hover table-fixed table-pages">
                            <thead>
                            <tr>
                                <th monTableSort
                                    monSortBy="title"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)">
                                    {{ 'Title and URL' | translate }}
                                </th>
                                <th class="col-sm-4 col-md-4 col-lg-4"
                                    monTableSort
                                    monSortBy="priority_score"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)">
                                    {{'Priority' | translate}}
                                </th>
                                <th class="col-lg-4 col-md-4 col-4"
                                    monTableSort
                                    monSortBy="hits"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)"
                                    *ngIf="viewsColumIsAvailable">
                                    {{'Views' | translate}}
                                </th>
                                <th class="col-sm-4 col-md-4 col-lg-6">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let page of pages">
                                <td>
                                    <div class="text-ellipsis">
                                        <mon-url-title
                                                *ngIf="!pageDetailsIsAvailable"
                                                [title]="page.title"
                                                [url]="page.url"
                                                [active]="false">
                                        </mon-url-title>
                                        <url-title-page-details
                                                *ngIf="pageDetailsIsAvailable"
                                                [target]="'page-details-section-seo'"
                                                [subTarget]="issue"
                                                class="inline-block"
                                                [page]="page"
                                                [title]="page.title"
                                                [url]="page.url"
                                                (onClose)="onPageDetailsClose()"
                                                [active]="false">
                                        </url-title-page-details>
                                    </div>
                                    <label-table *ngIf="showLabels"
                                                     [assignedLabels]="page.labels"
                                                     [existingLabels]="labels"
                                                     (getLabels)="getLabels()"
                                                     (onUpdateLabel)="updateLabels(page)">
                                    </label-table>
                                </td>
                                <td class="text-v-middle">
                                    <mon-priority class="vcenter" [priority]="page.priority_score_as_text"></mon-priority>
                                </td>
                                <td *ngIf="viewsColumIsAvailable" class="text-v-middle">
                                    <visits [title]="page.title" [visits]="page.hits" [totalVisits]="pages.pageHits"></visits>
                                </td>
                                <td class="d-flex align-items-center justify-content-end flex-wrap">
                                    <table-page-details
                                            ngbTooltip="{{ 'Open page details' | translate }}"
                                            [triggers]="'focus hover'"
                                            [target]="'page-details-section-seo'"
                                            [subTarget]="issue"
                                            [page]="page">
                                    </table-page-details>
                                    <mon-extension-visual-link-button class="ml-1" [page]="page" [type]="'seo'"></mon-extension-visual-link-button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </table-container>
                </div>
            </div>
        </div>
    </div>
</div>
